import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AISummaryScope } from 'src/interfaces/aiSummary.interface'
import { AISummaryApiService } from 'src/services/aiSummaryApi'

// One cache entry per scope — invalidate it after generating. A facility (and
// an AI Listening subject) is its own scope (own list, cooldown and daily
// cap). Not tied to the page date filter: the widget lists every stored
// period.
export const getAISummariesScopeKey = ({
  facilityId,
  id,
  kind,
  subject,
}: AISummaryScope) => [
  QueryKey.GET_AI_SUMMARIES,
  kind,
  id,
  facilityId ?? '-',
  subject ?? '-',
]

export const useGetAISummariesQuery = (scope: AISummaryScope) => {
  return useQuery({
    enabled: !!scope.id,
    queryFn: () => AISummaryApiService.getSummaries(scope),
    queryKey: getAISummariesScopeKey(scope),
  })
}
